import MeaDetailField from "../../../../components/MeaDetailField";
import MeaDetailCard from "../../../../components/MeaDetailCard";

const LevelDetailComponent = ({ level }) => {
  return (
    <>
      <MeaDetailCard>
        <MeaDetailField field="Nom du niveau" value={level?.name} />
        <MeaDetailField
          field="Présentation"
          value={level?.presentation || "-"}
        />
        <MeaDetailField
          field="Couleur"
          value={
            level?.color ? (
              <div
                style={{
                  width: "36px",
                  height: "22px",
                  backgroundColor: level.color,
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                }}
              />
            ) : (
              "-"
            )
          }
        />
      </MeaDetailCard>
    </>
  );
};

export default LevelDetailComponent;
